<script>
export default {
    name: 'IconQuoteEnd',
}
</script>

<template>
    <svg role="img"
        class="base-icon icon-quote-end"
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fill="currentColor"
            d="M44.987 13c-3.18 0-5.79.987-7.834 2.962-2.044 1.974-3.066 4.563-3.066 7.767 0 2.236.53 4.173 1.59 5.812.993 1.537 2.352 2.714 4.078 3.53l.35.158L35.109 51h11.24l6.585-16.094c1.287-2.98 2.12-5.216 2.498-6.706.379-1.49.568-2.98.568-4.47 0-3.13-1.04-5.7-3.122-7.712C50.796 14.006 48.166 13 44.987 13zM18.9 13c-3.18 0-5.79.987-7.834 2.962C9.022 17.936 8 20.525 8 23.729c0 2.236.53 4.173 1.59 5.812.993 1.537 2.352 2.714 4.078 3.53l.35.158L9.022 51h11.24l6.585-16.094c1.287-2.98 2.12-5.216 2.498-6.706.379-1.49.568-2.98.568-4.47 0-3.13-1.04-5.7-3.122-7.712C24.709 14.006 22.079 13 18.9 13z"
        />
    </svg>
</template>
